let zhaotongCommunity= [
  {
      "parentToken": "CN^^^云南省^^^昭通市^^^昭阳区",
      "children": [
          {
              "label": "凤凰街道",
              "value": "凤凰街道"
          },
          {
              "label": "龙泉街道",
              "value": "龙泉街道"
          },
          {
              "label": "太平街道",
              "value": "太平街道"
          },
          {
              "label": "旧圃镇",
              "value": "旧圃镇"
          },
          {
              "label": "永丰镇",
              "value": "永丰镇"
          },
          {
              "label": "北闸镇",
              "value": "北闸镇"
          },
          {
              "label": "盘河镇",
              "value": "盘河镇"
          },
          {
              "label": "靖安镇",
              "value": "靖安镇"
          },
          {
              "label": "洒渔镇",
              "value": "洒渔镇"
          },
          {
              "label": "乐居镇",
              "value": "乐居镇"
          },
          {
              "label": "苏家院镇",
              "value": "苏家院镇"
          },
          {
              "label": "大山包镇",
              "value": "大山包镇"
          },
          {
              "label": "炎山镇",
              "value": "炎山镇"
          },
          {
              "label": "布嘎回族乡",
              "value": "布嘎回族乡"
          },
          {
              "label": "守望回族乡",
              "value": "守望回族乡"
          },
          {
              "label": "小龙洞回族彝族乡",
              "value": "小龙洞回族彝族乡"
          },
          {
              "label": "青岗岭回族彝族乡",
              "value": "青岗岭回族彝族乡"
          },
          {
              "label": "苏甲乡",
              "value": "苏甲乡"
          },
          {
              "label": "大寨子乡",
              "value": "大寨子乡"
          },
          {
              "label": "田坝乡",
              "value": "田坝乡"
          }
      ]
  },
  {
      "parentToken": "CN^^^云南省^^^昭通市^^^鲁甸县",
      "children": [
          {
              "label": "文屏镇",
              "value": "文屏镇"
          },
          {
              "label": "水磨镇",
              "value": "水磨镇"
          },
          {
              "label": "龙头山镇",
              "value": "龙头山镇"
          },
          {
              "label": "小寨镇",
              "value": "小寨镇"
          },
          {
              "label": "江底镇",
              "value": "江底镇"
          },
          {
              "label": "火德红镇",
              "value": "火德红镇"
          },
          {
              "label": "龙树镇",
              "value": "龙树镇"
          },
          {
              "label": "新街镇",
              "value": "新街镇"
          },
          {
              "label": "梭山镇",
              "value": "梭山镇"
          },
          {
              "label": "乐红镇",
              "value": "乐红镇"
          },
          {
              "label": "桃源回族乡",
              "value": "桃源回族乡"
          },
          {
              "label": "茨院回族乡",
              "value": "茨院回族乡"
          }
      ]
  },
  {
      "parentToken": "CN^^^云南省^^^昭通市^^^巧家县",
      "children": [
          {
              "label": "白鹤滩镇",
              "value": "白鹤滩镇"
          },
          {
              "label": "大寨镇",
              "value": "大寨镇"
          },
          {
              "label": "小河镇",
              "value": "小河镇"
          },
          {
              "label": "药山镇",
              "value": "药山镇"
          },
          {
              "label": "马树镇",
              "value": "马树镇"
          },
          {
              "label": "老店镇",
              "value": "老店镇"
          },
          {
              "label": "茂租镇",
              "value": "茂租镇"
          },
          {
              "label": "东坪镇",
              "value": "东坪镇"
          },
          {
              "label": "新店镇",
              "value": "新店镇"
          },
          {
              "label": "崇溪镇",
              "value": "崇溪镇"
          },
          {
              "label": "金塘镇",
              "value": "金塘镇"
          },
          {
              "label": "蒙姑镇",
              "value": "蒙姑镇"
          },
          {
              "label": "红山乡",
              "value": "红山乡"
          },
          {
              "label": "包谷垴乡",
              "value": "包谷垴乡"
          },
          {
              "label": "中寨乡",
              "value": "中寨乡"
          },
          {
              "label": "炉房乡",
              "value": "炉房乡"
          }
      ]
  },
  {
      "parentToken": "CN^^^云南省^^^昭通市^^^盐津县",
      "children": [
          {
              "label": "盐井镇",
              "value": "盐井镇"
          },
          {
              "label": "普洱镇",
              "value": "普洱镇"
          },
          {
              "label": "豆沙镇",
              "value": "豆沙镇"
          },
          {
              "label": "中和镇",
              "value": "中和镇"
          },
          {
              "label": "庙坝镇",
              "value": "庙坝镇"
          },
          {
              "label": "柿子镇",
              "value": "柿子镇"
          },
          {
              "label": "兴隆乡",
              "value": "兴隆乡"
          },
          {
              "label": "落雁乡",
              "value": "落雁乡"
          },
          {
              "label": "滩头乡",
              "value": "滩头乡"
          },
          {
              "label": "牛寨乡",
              "value": "牛寨乡"
          }
      ]
  },
  {
      "parentToken": "CN^^^云南省^^^昭通市^^^大关县",
      "children": [
          {
              "label": "翠华镇",
              "value": "翠华镇"
          },
          {
              "label": "玉碗镇",
              "value": "玉碗镇"
          },
          {
              "label": "吉利镇",
              "value": "吉利镇"
          },
          {
              "label": "天星镇",
              "value": "天星镇"
          },
          {
              "label": "木杆镇",
              "value": "木杆镇"
          },
          {
              "label": "悦乐镇",
              "value": "悦乐镇"
          },
          {
              "label": "寿山镇",
              "value": "寿山镇"
          },
          {
              "label": "高桥镇",
              "value": "高桥镇"
          },
          {
              "label": "上高桥回族彝族苗族乡",
              "value": "上高桥回族彝族苗族乡"
          }
      ]
  },
  {
      "parentToken": "CN^^^云南省^^^昭通市^^^永善县",
      "children": [
          {
              "label": "溪洛渡镇",
              "value": "溪洛渡镇"
          },
          {
              "label": "桧溪镇",
              "value": "桧溪镇"
          },
          {
              "label": "黄华镇",
              "value": "黄华镇"
          },
          {
              "label": "茂林镇",
              "value": "茂林镇"
          },
          {
              "label": "大兴镇",
              "value": "大兴镇"
          },
          {
              "label": "莲峰镇",
              "value": "莲峰镇"
          },
          {
              "label": "务基镇",
              "value": "务基镇"
          },
          {
              "label": "码口镇",
              "value": "码口镇"
          },
          {
              "label": "团结乡",
              "value": "团结乡"
          },
          {
              "label": "细沙乡",
              "value": "细沙乡"
          },
          {
              "label": "青胜乡",
              "value": "青胜乡"
          },
          {
              "label": "马楠苗族彝族乡",
              "value": "马楠苗族彝族乡"
          },
          {
              "label": "水竹乡",
              "value": "水竹乡"
          },
          {
              "label": "墨翰乡",
              "value": "墨翰乡"
          },
          {
              "label": "伍寨彝族苗族乡",
              "value": "伍寨彝族苗族乡"
          }
      ]
  },
  {
      "parentToken": "CN^^^云南省^^^昭通市^^^绥江县",
      "children": [
          {
              "label": "中城镇",
              "value": "中城镇"
          },
          {
              "label": "南岸镇",
              "value": "南岸镇"
          },
          {
              "label": "新滩镇",
              "value": "新滩镇"
          },
          {
              "label": "会仪镇",
              "value": "会仪镇"
          },
          {
              "label": "板栗镇",
              "value": "板栗镇"
          }
      ]
  },
  {
      "parentToken": "CN^^^云南省^^^昭通市^^^镇雄县",
      "children": [
          {
              "label": "乌峰镇",
              "value": "乌峰镇"
          },
          {
              "label": "泼机镇",
              "value": "泼机镇"
          },
          {
              "label": "黑树镇",
              "value": "黑树镇"
          },
          {
              "label": "母享镇",
              "value": "母享镇"
          },
          {
              "label": "大湾镇",
              "value": "大湾镇"
          },
          {
              "label": "以勒镇",
              "value": "以勒镇"
          },
          {
              "label": "赤水源镇",
              "value": "赤水源镇"
          },
          {
              "label": "芒部镇",
              "value": "芒部镇"
          },
          {
              "label": "雨河镇",
              "value": "雨河镇"
          },
          {
              "label": "罗坎镇",
              "value": "罗坎镇"
          },
          {
              "label": "牛场镇",
              "value": "牛场镇"
          },
          {
              "label": "五德镇",
              "value": "五德镇"
          },
          {
              "label": "坡头镇",
              "value": "坡头镇"
          },
          {
              "label": "以古镇",
              "value": "以古镇"
          },
          {
              "label": "场坝镇",
              "value": "场坝镇"
          },
          {
              "label": "塘房镇",
              "value": "塘房镇"
          },
          {
              "label": "中屯镇",
              "value": "中屯镇"
          },
          {
              "label": "木卓镇",
              "value": "木卓镇"
          },
          {
              "label": "盐源镇",
              "value": "盐源镇"
          },
          {
              "label": "碗厂镇",
              "value": "碗厂镇"
          },
          {
              "label": "坪上镇",
              "value": "坪上镇"
          },
          {
              "label": "鱼洞乡",
              "value": "鱼洞乡"
          },
          {
              "label": "花朗乡",
              "value": "花朗乡"
          },
          {
              "label": "尖山乡",
              "value": "尖山乡"
          },
          {
              "label": "杉树乡",
              "value": "杉树乡"
          },
          {
              "label": "花山乡",
              "value": "花山乡"
          },
          {
              "label": "果珠彝族乡",
              "value": "果珠彝族乡"
          },
          {
              "label": "林口彝族苗族乡",
              "value": "林口彝族苗族乡"
          }
      ]
  },
  {
      "parentToken": "CN^^^云南省^^^昭通市^^^彝良县",
      "children": [
          {
              "label": "角奎镇",
              "value": "角奎镇"
          },
          {
              "label": "洛泽河镇",
              "value": "洛泽河镇"
          },
          {
              "label": "牛街镇",
              "value": "牛街镇"
          },
          {
              "label": "海子镇",
              "value": "海子镇"
          },
          {
              "label": "荞山镇",
              "value": "荞山镇"
          },
          {
              "label": "龙安镇",
              "value": "龙安镇"
          },
          {
              "label": "钟鸣镇",
              "value": "钟鸣镇"
          },
          {
              "label": "两河镇",
              "value": "两河镇"
          },
          {
              "label": "小草坝镇",
              "value": "小草坝镇"
          },
          {
              "label": "龙海镇",
              "value": "龙海镇"
          },
          {
              "label": "龙街苗族彝族乡",
              "value": "龙街苗族彝族乡"
          },
          {
              "label": "奎香苗族彝族乡",
              "value": "奎香苗族彝族乡"
          },
          {
              "label": "树林彝族苗族乡",
              "value": "树林彝族苗族乡"
          },
          {
              "label": "柳溪苗族乡",
              "value": "柳溪苗族乡"
          },
          {
              "label": "洛旺乡",
              "value": "洛旺乡"
          }
      ]
  },
  {
      "parentToken": "CN^^^云南省^^^昭通市^^^威信县",
      "children": [
          {
              "label": "扎西镇",
              "value": "扎西镇"
          },
          {
              "label": "旧城镇",
              "value": "旧城镇"
          },
          {
              "label": "罗布镇",
              "value": "罗布镇"
          },
          {
              "label": "麟凤镇",
              "value": "麟凤镇"
          },
          {
              "label": "长安镇",
              "value": "长安镇"
          },
          {
              "label": "庙沟镇",
              "value": "庙沟镇"
          },
          {
              "label": "水田镇",
              "value": "水田镇"
          },
          {
              "label": "双河苗族彝族乡",
              "value": "双河苗族彝族乡"
          },
          {
              "label": "高田乡",
              "value": "高田乡"
          },
          {
              "label": "三桃乡",
              "value": "三桃乡"
          }
      ]
  },
  {
      "parentToken": "CN^^^云南省^^^昭通市^^^水富市",
      "children": [
          {
              "label": "云富街道",
              "value": "云富街道"
          },
          {
              "label": "向家坝镇",
              "value": "向家坝镇"
          },
          {
              "label": "太平镇",
              "value": "太平镇"
          },
          {
              "label": "两碗镇",
              "value": "两碗镇"
          }
      ]
  }
]
export { zhaotongCommunity };